import React from 'react';
import PropTypes from 'prop-types';

const NewTermAgreementGroup = ({
    multiCheckContext,
    requiredTerms,
    optionalTerms,
    onTermClick,
}) => {
    const handleTermView = (url) => {
        if (onTermClick) {
            onTermClick(url);
        } else {
            window.open(url, '_blank');
        }
    };

    const renderTermItem = (term, suffix) => (
        <div key={term.id} className="agree-detail-item">
            <input
                type="checkbox"
                id={term.id}
                name={term.id}
                checked={term.checked}
                onChange={term.onChange}
            />
            <label htmlFor={term.id}>
                {term.label} {suffix}
            </label>
            <button
                type="button"
                className="term-view-btn"
                onClick={() => handleTermView(term.url)}
            >
                보기
            </button>
        </div>
    );

    return (
        <div className="new-agree-wrap terms">
            {/* 전체 동의 */}
            <div className="all-check">
                <input
                    type="checkbox"
                    id="multi-check-all"
                    name="multi-check-all"
                    checked={multiCheckContext.checked}
                    value={multiCheckContext.value}
                    onChange={multiCheckContext.onChange}
                />
                <label htmlFor="multi-check-all">
                    {multiCheckContext.label}
                </label>
                {multiCheckContext.description && (
                    <small>{multiCheckContext.description}</small>
                )}
            </div>

            {/* 약관 항목 (항상 펼침) */}
            <div className="agree-detail-list">
                {requiredTerms.map((term) => renderTermItem(term, '[필수]'))}
                {optionalTerms.map((term) => renderTermItem(term, '[선택]'))}
            </div>
        </div>
    );
};

NewTermAgreementGroup.propTypes = {
    multiCheckContext: PropTypes.shape({
        label: PropTypes.string,
        description: PropTypes.string,
        value: PropTypes.bool,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
    }),
    requiredTerms: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
            url: PropTypes.string,
            checked: PropTypes.bool,
            onChange: PropTypes.func,
        })
    ),
    optionalTerms: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
            url: PropTypes.string,
            checked: PropTypes.bool,
            onChange: PropTypes.func,
        })
    ),
    onTermClick: PropTypes.func,
};

export default NewTermAgreementGroup;
